import React, { useEffect, useState } from "react";
import i18n from "i18next";

// Fabric Imports

import { fetchWrapper } from "../../helpers/fetchwrapper";

import useWindowSize from "../../helpers/useWindowSize";
import { baseUrl } from "../../helpers/constants";

import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Field,
} from "@fluentui/react-components";
import LuebPersonaPicker from "../../Controls/LuebPersonaPicker";
import { IAppUserDto } from "../../Models/IAppUserDto";
import { IAcademyDocumentFolder2AppUser } from "../../Models/IAcademyDocument2AppUser";

interface IAddAcademyFolderDialogProps {
  isDialogOpen: boolean;
  academyDocumentFolderGuid: string;
  onDismiss: any;
  allUsers: IAppUserDto[];
  academyDocumentFolder2AppUsersIDs: IAcademyDocumentFolder2AppUser[];
}

function AddAcademyParticipantDialog(props: IAddAcademyFolderDialogProps) {
  const [userGuid, setUserGuid] = useState<string>("");
  const [isObserver, setIsObserver] = useState<boolean>(false);

  const windowSize = useWindowSize();

  const addAcademyParticipant = () => {
    if (userGuid) {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/academy/AddUserToFolder?appUserGuid=${userGuid}&academyDocumentFolderGuid=${props.academyDocumentFolderGuid}&isObserver=${isObserver}`,
        )
        .then(() => {
          props.onDismiss();
        });
    }
  };

  const CurrentUsers = props.academyDocumentFolder2AppUsersIDs.map((item) => {
    return item.appUser?.id;
  });

  return (
    <Dialog open={props.isDialogOpen} onOpenChange={() => props.onDismiss()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            {i18n.t<string>("addAcademyParticipantDialogTitle")}
          </DialogTitle>
          <DialogContent>
            {i18n.t<string>("addAcademyParticipantDialogText")}
            <Field
              size="large"
              label={i18n.t<string>("participant")}
              style={{ maxWidth: 400 }}
            >
              <LuebPersonaPicker
                showPicture={false}
                users={props.allUsers.filter(
                  (user) => !CurrentUsers.includes(user.id),
                )}
                selectedUsers={props.allUsers.filter(
                  (x) =>
                    userGuid != undefined &&
                    x.id != undefined &&
                    userGuid == x.id,
                )}
                onSelectSamAccountName={(userId: string) => {
                  if (userId) {
                    setUserGuid(userId);
                  } else {
                    setUserGuid("");
                  }
                }}
                onRemoveSamAccountName={(userId: string) => {
                  setUserGuid("");
                }}
              />
            </Field>
            <Checkbox
              checked={isObserver}
              onChange={(ev, data) => {
                setIsObserver(data.checked ? true : false);
              }}
              label={i18n.t("isObserver")}
            />
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button
                onClick={() => {
                  props.onDismiss();
                }}
                appearance="secondary"
              >
                {i18n.t<string>("cancel")}
              </Button>
            </DialogTrigger>
            <Button
              disabled={userGuid == undefined || userGuid == ""}
              onClick={() => {
                addAcademyParticipant();
              }}
              appearance="primary"
            >
              {i18n.t<string>("add")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default AddAcademyParticipantDialog;
